import { render, staticRenderFns } from "./TargetPreparation.vue?vue&type=template&id=bdf2efe6&"
import script from "./TargetPreparation.vue?vue&type=script&lang=js&"
export * from "./TargetPreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports